import React from 'react';
import styled from 'styled-components';
import { COLORS } from '../../Styles/Colors';
import { FORM } from './formStyles';
import { FormShell, FormBody, FormTitle, FormSubtitle, FormHeader } from './FormLayout';
import { FormActions } from './FormActions';

const ImportZone = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  padding: 32px 24px;
  border: 2px dashed ${FORM.border};
  border-radius: ${FORM.borderRadius};
  background: ${FORM.surface};
  text-align: center;
`;

const InstructionText = styled.p`
  margin: 0;
  color: ${FORM.textMuted};
  font-size: 0.875rem;
  line-height: 1.55;
  max-width: 420px;
`;

const FileInput = styled.input`
  padding: 10px 14px;
  font-size: 0.875rem;
  border: 1px solid ${FORM.border};
  border-radius: ${FORM.fieldRadius};
  background: ${COLORS.white};
  cursor: pointer;
  width: 100%;
  max-width: 360px;

  &:hover {
    border-color: ${COLORS.teal};
  }
`;

interface FormImportLayoutProps {
  title?: string;
  subtitle?: string;
  instruction: string;
  onSubmit: (e: React.FormEvent) => void;
  onCancel?: () => void;
  submitLabel?: string;
  isLoading?: boolean;
  disabled?: boolean;
  accept?: string;
  fileInputRef?: React.RefObject<HTMLInputElement>;
  onFileChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  children?: React.ReactNode;
}

export const FormImportLayout: React.FC<FormImportLayoutProps> = ({
  title = 'Bulk Import',
  subtitle,
  instruction,
  onSubmit,
  onCancel,
  submitLabel = 'Import',
  isLoading,
  disabled,
  accept = '.csv,.xlsx,.xls',
  fileInputRef,
  onFileChange,
  children,
}) => (
  <FormShell $compact>
    <form onSubmit={onSubmit} style={{ display: 'flex', flexDirection: 'column' }}>
      <FormHeader>
        <FormTitle>{title}</FormTitle>
        {subtitle && <FormSubtitle>{subtitle}</FormSubtitle>}
      </FormHeader>
      <FormBody>
        <ImportZone>
          <InstructionText>{instruction}</InstructionText>
          <FileInput
            ref={fileInputRef}
            type="file"
            accept={accept}
            onChange={onFileChange}
            required
          />
          {children}
        </ImportZone>
      </FormBody>
      <FormActions
        submitLabel={submitLabel}
        onCancel={onCancel}
        isLoading={isLoading}
        disabled={disabled}
      />
    </form>
  </FormShell>
);
